(function () {
 document.querySelectorAll('[data-rd-fs-guides-section]').forEach(function(holder) {
 if(holder.dataset.ready) return; holder.dataset.ready='true';
 var id=holder.dataset.rdFsGuidesSection; var root=document.getElementById('shopify-section-' + id);
  /* Size guide dialog */
  var sgModal = null;
  var sgTrigger = null;
  var compSgModals = Array.from(document.querySelectorAll('.rd-bundle-comp-sg[data-section="' + id + '"]'));
  var sgModals = (sgModal ? [sgModal] : []).concat(compSgModals);
  var activeSgModal = null;
  var activeSgTrigger = null;
  var sgCloseTimers = new WeakMap();
  var sgFocusableSelector = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getSgFocusable(modal) {
    return Array.from(modal.querySelectorAll(sgFocusableSelector)).filter(function(element) {
      if (element.hidden || element.closest('[hidden], [aria-hidden="true"]')) return false;
      var style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
  }

  function setSgTriggerState(trigger, isOpen) {
    if (trigger) trigger.setAttribute('aria-expanded', String(isOpen));
  }

  function focusSgDialog(modal) {
    var focusable = getSgFocusable(modal);
    var close = modal.querySelector('[data-rd-size-guide-close]');
    var target = close && focusable.indexOf(close) !== -1 ? close : focusable[0];
    (target || modal).focus({ preventScroll: true });
  }

  function openSgDrawer(modal, trigger) {
    if (!modal) return;
    if (activeSgModal && activeSgModal !== modal) closeSgDrawer(activeSgModal, false);
    var closeTimer = sgCloseTimers.get(modal);
    if (closeTimer) {
      clearTimeout(closeTimer);
      sgCloseTimers.delete(modal);
    }
    activeSgModal = modal;
    activeSgTrigger = trigger || null;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    setSgTriggerState(activeSgTrigger, true);
    requestAnimationFrame(function() {
      if (activeSgModal !== modal) return;
      modal.classList.add('rd-sg--open');
      focusSgDialog(modal);
      setTimeout(function() { lockInfoHeights(modal); }, 320);
    });
  }

  function closeSgDrawer(modal, restoreFocus) {
    modal = modal || activeSgModal;
    if (!modal) return;
    if (restoreFocus === undefined) restoreFocus = true;
    var trigger = modal === activeSgModal ? activeSgTrigger : null;
    modal.classList.remove('rd-sg--open');
    modal.setAttribute('aria-hidden', 'true');
    setSgTriggerState(trigger, false);
    if (activeSgModal === modal) {
      activeSgModal = null;
      activeSgTrigger = null;
    }
    var closeTimer = setTimeout(function() {
      modal.hidden = true;
      sgCloseTimers.delete(modal);
      if (restoreFocus && trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
    }, 320);
    sgCloseTimers.set(modal, closeTimer);
  }

  if (sgTrigger) sgTrigger.addEventListener('click', function() { openSgDrawer(sgModal, sgTrigger); });
  if (root) {
    // Delegate so the selected top's dynamically rendered guide uses the same drawer.
    root.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-size-guide-target]');
      if (!trigger || !root.contains(trigger)) return;
      var target = trigger.getAttribute('data-size-guide-target');
      openSgDrawer(document.getElementById('rd-bundle-sg-' + target + '-' + id), trigger);
    });
  }
  sgModals.forEach(function(modal) {
    var drawer = modal.querySelector('.rd-sg__drawer');
    var close = modal.querySelector('[data-rd-size-guide-close]');
    if (close) close.addEventListener('click', function() { closeSgDrawer(modal); });
    modal.addEventListener('click', function(event) {
      if (drawer && !drawer.contains(event.target)) closeSgDrawer(modal);
    });
    modal.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeSgDrawer(modal);
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = getSgFocusable(modal);
      if (!focusable.length) {
        event.preventDefault();
        modal.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!modal.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    initSgModal(modal);
  });

  function lockInfoHeights(modal) {
    if (!modal || modal.dataset.infoHeightLocked === 'true') return;
    var featured = modal.querySelector('.rd-sg__featured');
    if (!featured) return;
    var panels = Array.from(featured.querySelectorAll('.rd-sg__panel'));
    var maxH = 0;
    panels.forEach(function(panel) {
      var wasHidden = panel.hidden;
      panel.hidden = false;
      var info = panel.querySelector('.rd-sg__featured-info');
      if (info) maxH = Math.max(maxH, info.offsetHeight);
      panel.hidden = wasHidden;
    });
    if (maxH > 0) {
      panels.forEach(function(panel) {
        var info = panel.querySelector('.rd-sg__featured-info');
        if (info) info.style.minHeight = maxH + 'px';
      });
    }
    modal.dataset.infoHeightLocked = 'true';
  }

  function initSgModal(modal) {
    var featured = modal.querySelector('.rd-sg__featured');

    if (!featured) return;

    featured.addEventListener('click', function(event) {
      var pill = event.target.closest('.rd-sg__pill');
      if (!pill) return;
      var target = pill.dataset.panel;
      Array.from(featured.querySelectorAll('.rd-sg__panel')).forEach(function(panel) {
        panel.hidden = panel.dataset.panel !== target;
      });
      featured.querySelectorAll('.rd-sg__pill').forEach(function(item) {
        item.classList.toggle('rd-sg__pill--active', item.dataset.panel === target);
      });
    });

    featured.querySelectorAll('.rd-sg__panel').forEach(function(panel) {
      var carousel = panel.querySelector('.rd-sg__carousel');
      var dotsBar = panel.querySelector('.rd-sg__panel-dots');
      var prevBtn = panel.querySelector('.rd-sg__nav-btn--prev');
      var nextBtn = panel.querySelector('.rd-sg__nav-btn--next');
      if (!carousel) return;
      var dots = dotsBar ? Array.from(dotsBar.querySelectorAll('.rd-sg__panel-dot')) : [];
      var slides = Array.from(carousel.querySelectorAll('.rd-sg__carousel-slide'));

      function getClosest() {
        var closest = 0;
        slides.forEach(function(slide, index) {
          if (Math.abs(slide.offsetLeft - carousel.scrollLeft) < Math.abs(slides[closest].offsetLeft - carousel.scrollLeft)) closest = index;
        });
        return closest;
      }

      function goToSlide(index) {
        if (slides[index]) carousel.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      }

      if (dotsBar) {
        dotsBar.addEventListener('click', function(event) {
          var dot = event.target.closest('.rd-sg__panel-dot');
          if (!dot) return;
          goToSlide(parseInt(dot.dataset.dot));
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          goToSlide(Math.max(0, getClosest() - 1));
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          goToSlide(Math.min(slides.length - 1, getClosest() + 1));
        });
      }

      carousel.addEventListener('scroll', function() {
        var closest = getClosest();
        dots.forEach(function(dot, index) {
          dot.classList.toggle('rd-sg__panel-dot--active', index === closest);
        });
      }, { passive: true });
    });
  }
 });
})();
